import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { ApplicantStatusesEnum } from '@thinknet-gmbh/platform-common';

export const APPLICANTS_STATUSES_STYLES = {
  [ApplicantStatusesEnum.NEW]: {
    background: PLATFORM_THEME_COLORS.tone.lightPurple,
    fontColor: PLATFORM_THEME_COLORS.tone.purple,
  },
  [ApplicantStatusesEnum.INTERVIEW_PHASE]: {
    background: PLATFORM_THEME_COLORS.tone.lightBlue,
    fontColor: PLATFORM_THEME_COLORS.primary.blue,
  },
  [ApplicantStatusesEnum.OFFER_SENT]: {
    background: PLATFORM_THEME_COLORS.allowedColorsToUse.green.light,
    fontColor: PLATFORM_THEME_COLORS.allowedColorsToUse.green.normal,
  },
  [ApplicantStatusesEnum.CANDIDATE_REVIEW]: {
    background: PLATFORM_THEME_COLORS.tone.lightYellow,
    fontColor: PLATFORM_THEME_COLORS.tone.yellow,
  },
  [ApplicantStatusesEnum.HIRED]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [ApplicantStatusesEnum.QUESTIONNAIRE_SENT]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [ApplicantStatusesEnum.REFUSED]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
  [ApplicantStatusesEnum.OFFER_ACCEPTED]: {
    background: PLATFORM_THEME_COLORS.allowedColorsToUse.blue.light,
    fontColor: PLATFORM_THEME_COLORS.allowedColorsToUse.blue.normal,
  },
};
